import { render, staticRenderFns } from "./TimetableNotice.vue?vue&type=template&id=760e17b6&scoped=true&"
import script from "./TimetableNotice.vue?vue&type=script&lang=js&"
export * from "./TimetableNotice.vue?vue&type=script&lang=js&"
import style0 from "./TimetableNotice.vue?vue&type=style&index=0&id=760e17b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e17b6",
  null
  
)

export default component.exports